import { Card, Progress, Label } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { observer } from 'mobx-react-lite';
import './dashboard.css';
import { useStore } from '../../../app/stores/store';
import StepL2ForOrders from '../StepContainerOrders/StepL2ForOrders';
import DashboardShowGrid from './DashboardShowGrid';
import StepL2ForInventory from '../StepContainerInventory/StepL2ForInventory';
import StepL2ForPlanning from '../StepContainerProduction/StepL2ForPlanning';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useEffect } from 'react';
import { cardcolor2 } from '../../../app/common/form/errorMessageText';
import UnauthorizedMessage from '../../UnauthorizedMessage';
import LoadingComponent from './../../../app/layout/LoadingComponent';
import React from 'react';
import { useNavigate } from 'react-router';

function Dashboard() {
  const history = useNavigate();
  const {
    dashboardStore,
    userStore,
    PivotStore,
    commonStore,
    userStore: { InstantpageRedirectoption },
    viewStore:{ HandleRoleBasedUserList}
  } = useStore();

  useEffect(() => {
    InstantpageRedirectoption();
    if(commonStore.NFAIReportCustomer) HandleRoleBasedUserList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (commonStore.filterModeOne.includes('DL1B1')) {
      dashboardStore.dashboard.L1CardValue = 'Inventory';
    } else {
      if (commonStore.filterModeOne.includes('DL1B2')) {
        dashboardStore.dashboard.L1CardValue = 'Orders';
      } else if (commonStore.filterModeOne.includes('DL1B3')) {
        dashboardStore.dashboard.L1CardValue = 'Production';
      } else {
        dashboardStore.dashboard.L1CardValue = '';
      }
    }
    // eslint-disable-next-line
  }, [commonStore.filterModeTwo, commonStore.filterModeOne]);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(userStore.user!.id,commonStore.NFAIReportCustomer);
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      if(!commonStore.RestorationCustomer && !commonStore.NFAIReportCustomer) dashboardStore.InventoryCountData();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('DB02') && <UnauthorizedMessage />}

      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        dashboardStore.dashboard.selectedUserRoleId.includes('DB02') && (
          <React.Fragment>
            <Card.Group centered style={{ marginBottom: '0px' }}>
              {commonStore.filterModeTwo?.includes('DL1B1') ? (
                <></>
              ) : (
                <Card
                  className={
                    !commonStore.filterModeZero?.includes('DL1B1')
                      ? 'card-selected-enabled'
                      : 'card-not-selected-disabled'
                  }
                  onClick={() => dashboardStore.openL2Cards('Inventory', 30)}
                  style={
                    dashboardStore.dashboard.L1CardValue === 'Inventory'
                      ? cardcolor2
                      : null
                  }
                >
                  <Card.Content>
                    {dashboardStore.dashboard.loadingCount ? (
                      <LoadingComponent />
                    ) : (
                      <>
                        <Label value={20} style={{ float: 'right' }} circular>
                          {commonStore.hfcCustomerChanges?dashboardStore.dashboard.inventoryCount2: dashboardStore.dashboard.inventoryCount}
                        </Label>
                        <Card.Header>
                          {
                            (userLanguage[0].DashboardLevel1.DL1B1 as any)[
                              `${commonStore.language.key}`
                            ]
                          }
                        </Card.Header>

                        <Card.Meta style={{ height: '30px' }}></Card.Meta>
                        <Card.Description>
                          {
                            (userLanguage[0].DashboardLevel1?.DL1L1 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          : {commonStore.hfcCustomerChanges?dashboardStore.dashboard.inventoryCount2: dashboardStore.dashboard.inventoryCount}
                        </Card.Description>
                      </>
                    )}
                  </Card.Content>
                </Card>
              )}
              {userStore.user?.customerName !== 'LVPCMS' &&
                userStore.user?.customerName !== 'Area 51' &&
                userStore.user?.customerName !== 'NFAI' &&
                !commonStore.filterModeTwo.includes('DL1B2') && (
                  <Card
                    className={
                      !commonStore.filterModeZero?.includes('DL1B2')
                        ? 'card-selected1-enabled'
                        : 'card-not-selected1-disabled'
                    }
                    onClick={() => dashboardStore.openL2Cards('Orders', 10)}
                    style={
                      dashboardStore.dashboard.L1CardValue === 'Orders'
                        ? cardcolor2
                        : null
                    }
                  >
                    <Card.Content>
                      {dashboardStore.dashboard.loadingCount ? (
                        <LoadingComponent />
                      ) : (
                        <>
                          <Label
                            value={20}
                            style={{
                              float: 'right',
                            }}
                            circular
                          >
                            {
                              commonStore.hfcCustomerChanges 
                                ? dashboardStore.dashboard.movementCount 
                                : `${dashboardStore.dashboard.completedOrderCount}/${dashboardStore.dashboard.totalOrderCount}`
                            }
                          </Label>
                          <Card.Header>
                            {
                              commonStore.hfcCustomerChanges ? 'Movements' :
                              (userLanguage[0].DashboardLevel1.DL1B2 as any)[
                                `${commonStore.language.key}`
                              ]
                            }
                          </Card.Header>
                          <Card.Meta>
                            {commonStore.hfcCustomerChanges ? <Card.Meta style={{ height: '30px' }}></Card.Meta>:
                            <Progress
                              className="dashboardProgressBar"
                              style={{
                                marginTop: '10px',
                              }}
                              percent={
                                (dashboardStore.dashboard.completedOrderCount /
                                  dashboardStore.dashboard.totalOrderCount) *
                                100
                              }
                              size="tiny"
                            />
                          }
                          </Card.Meta>
                          <Card.Description>
                            {
                              (userLanguage[0].DashboardLevel1?.DL1L2 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                            :{' '}
                            { !commonStore.hfcCustomerChanges ? dashboardStore.dashboard.totalOrderCount -
                              dashboardStore.dashboard.completedOrderCount: dashboardStore.dashboard.movementCount}
                          </Card.Description>
                        </>
                      )}
                    </Card.Content>
                  </Card>
                )}

              {commonStore.filterModeTwo?.includes('DL1B3') ? (
                <></>
              ) : (
                <Card
                  className={
                    !commonStore.filterModeZero?.includes('DL1B3')
                      ? 'card-selected2-enabled'
                      : 'card-not-selected2-disabled'
                  }
                  onClick={() => dashboardStore.openL2Cards('Production', 50)}
                  style={
                    dashboardStore.dashboard.L1CardValue === 'Production'
                      ? cardcolor2
                      : null
                  }
                >
                  <Card.Content>
                    {dashboardStore.dashboard.loadingCount ? (
                      <LoadingComponent />
                    ) : (
                      <>
                        <Label style={{ float: 'right' }} circular>
                          {dashboardStore.dashboard.prodCount}
                        </Label>
                        <Card.Header>
                          {
                            (userLanguage[0].DashboardLevel1.DL1B3 as any)[
                              `${commonStore.language.key}`
                            ]
                          }
                        </Card.Header>
                        <Card.Meta>
                          <Progress
                            className="dashboardProgressBar"
                            style={{
                              marginTop: '10px',
                            }}
                            percent={
                              (dashboardStore.dashboard.taskCount /
                                dashboardStore.dashboard.taskTotal) *
                              100
                            }
                            size="tiny"
                          />
                        </Card.Meta>
                        <Card.Description
                        //Completed //out of // Tasks
                        >
                          {/* {
                            (userLanguage[0].DashboardLevel1?.DL1L3A as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }{' '}
                          {dashboardStore.dashboard.taskCount}{' '}
                          {
                            (userLanguage[0].DashboardLevel1?.DL1L3B as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }{' '}
                          {dashboardStore.dashboard.taskTotal}{' '}
                          {
                            (userLanguage[0].DashboardLevel1?.DL1L3C as any)?.[
                              `${commonStore.language.key}`
                            ]
                          } */}
                          Total Number of Tasks:{' '}
                          {dashboardStore.dashboard.taskTotal}
                        </Card.Description>
                      </>
                    )}
                  </Card.Content>
                </Card>
              )}
              {PivotStore.pinnedIDForUser?.pinnedAssets?.map((ids) => {
                // eslint-disable-next-line
                return (
                  PivotStore.saveAsPivotDataAll.length > 0 &&
                  PivotStore.saveAsPivotDataAll.map((saveas) => {
                    if (ids === saveas.id) {
                      return (
                        <Card
                          className={
                            dashboardStore.dashboard.selectedUserRoleId?.includes(
                              'DL1B3',
                            )
                              ? 'card-enabled-dynamic'
                              : 'card-disabled-dynamic'
                          }
                          onClick={() =>
                            history(`/pivotsaveasreport/${saveas.id}`)
                          }
                          // style={ //   dashboardStore.dashboard.L1CardValue === "Production" //     ? cardcolor2 //     : null // }
                        >
                          <Card.Content>
                            <Card.Header
                              style={{
                                fontSize: '15.5px',
                              }}
                            >
                              {saveas.tableName}
                            </Card.Header>
                            <Card.Meta></Card.Meta>
                            <Card.Description
                            //Pinned Feature
                            >
                              {
                                (
                                  userLanguage[0].DashboardLevel1?.DL1L4A as any
                                )?.[`${commonStore.language.key}`]
                              }
                            </Card.Description>
                          </Card.Content>
                        </Card>
                      );
                    } else return <></>;
                  })
                );
              })}
            </Card.Group>
            <div style={{ margin: '0 16px 16px 16px' }}>
              {dashboardStore.dashboard.L1CardValue === 'Inventory' ? (
                <>
                  {(userStore.user?.customerName !== 'NFAI' ||
                    window.innerWidth > 1025 ||
                    window.innerWidth < 1020) && <StepL2ForInventory />}
                </>
              ) : dashboardStore.dashboard.L1CardValue === 'Orders' ? (
                <StepL2ForOrders />
              ) : dashboardStore.dashboard.L1CardValue === 'Production' ? (
                <StepL2ForPlanning />
              ) : (
                <></>
              )}
            </div>
            {dashboardStore.dashboard.L2CardValueInventory === 'Receiving' ? (
              <></>
            ) : null}

            {dashboardStore.dashboard.L2CardValueOrders === 'Incoming' ? (
              <></>
            ) : null}
            <DashboardShowGrid />
          </React.Fragment>
        )}
    </div>
  );
}

export default observer(Dashboard);
